import { ResponseSignIn } from '../CommerceLayer'
import { Country } from '../../types'

export enum ImportStatus {
  PENDING = 'pending',
  IN_PROGRESS = 'in_progress',
  INTERRUPTED = 'interrupted',
  COMPLETED = 'completed',
}

export interface CustomerAuthResponse {
  access_token: string
  token_type: string
  expires_in: number
  refresh_token: string
  scope: string
  created_at: number
  owner_type: string
  owner_id: string
  resource_owner_id: string
}

export interface AuthenticateWithGoogleResponse {
  token: ResponseSignIn
  ownerId: string
  isInfoComplete: boolean
}

export interface ConfirmPaymentParams {
  authorizationNumber: string
  country: Country
  otp: string
  orderId: string
}

export interface ConfirmPaymentResponse {
  statusCode: number
  message: string
  error: string
}
